/**
 * Query all measurement records with their group information.
 * @param database - Opened SQLite database handle
 * @returns Array of raw record rows
 */
export function readRecords(database) {
    const rows = database.selectObjects(`
    SELECT
      r.Id           AS id,
      r.Guid         AS guid,
      r.CreatedDateTime   AS createdDateTime,
      r.ModifiedDateTime  AS modifiedDateTime,
      r.RootParameterTypeId AS rootParameterTypeId,
      g.Id           AS groupId,
      g.Guid         AS groupGuid,
      g.GivenName    AS groupName
    FROM StandardRecords r
    JOIN StandardRecordGroups g ON r.GroupId = g.Id
    ORDER BY r.Id
  `);
    return rows;
}
//# sourceMappingURL=readRecords.js.map